import { useEffect, useState } from "react";
import {
  Svg,
  Circle,
  Pos,
  Lab,
  Outer,
  Text1,
  Text2,
  CircleGroup,
  LabContainer,
  Text3,
  InnerLabelOuter,
} from "../OverviewLabel/Overview.label.style";

import { useLocation } from "react-router-dom";
import { useClick } from "../OverviewLabel/Overview.label.click";
import { useBreak } from "hooks/useBreak";

export const InnerDesktopLabel = ({
  scale,
  c,
  sc,
  d,
  l,
  rmode,
  r,
  // clr, // ✅ REQUIRED
  labelsInfo,
  heading,
  mobileLabelAxis,
  hoveredId,
}) => {
  const isMobile = useBreak("md_dn");
  const click = useClick();
  const here = useLocation().pathname.split("/");

  const isIsometry = here[here.length - 2] === "isometry";


  const [notHovered, setNotHovered] = useState(true);

  const s = 0.6 / sc === Infinity ? 10 : 0.6 / sc;
  const cx = r?.[0];
  const cy = r?.[1];

  const dl = { d, l, s, notHovered };

  /* --------------------------------
     ✅ FIXED EXPANSION CONDITION
  -------------------------------- */
  const isThisCommunityLabel =
  (hoveredId === "commooom1" && labelsInfo?.id === "common1") ||
  (hoveredId === "commooom2" && labelsInfo?.id === "common2");
  const isExpanded =
  
   isThisCommunityLabel

  useEffect(() => {
    setNotHovered(!isExpanded);
  }, [isExpanded]);

  /* --------------------------------
     ✅ COMMUNITY DESCRIPTION
  -------------------------------- */
  const getCommunityText = (id) => {
    if (id === "commooom1") {
      return "Væksthus hvor man kan nyde en kop kaffe eller hinandens fællesskab";
    }
    if (id === "commooom2") {
      return "Fællesrum på 300 kvm til fri afbenyttelse for lejerne";
    }
    return null;
  };

  if (!isIsometry || rmode) return null;

  return (
    <Pos
      c={c}
      style={{
        position: "absolute",
         transform: `scale(${2.4})`,
      }}
    >
      <Svg viewBox="0 0 100 100">
        <CircleGroup transform={`translate(${cx} ${cy})`}>
          {/* ✅ clr preserved */}
          <Circle cx={0} cy={0} r={15} clr={clr} />
          <Circle cx={0} cy={0} r={25} fillOpacity="0.5" clr={clr} />
          <Circle cx={0} cy={0} r={35} fillOpacity="0.3" clr={clr} />
        </CircleGroup>
      </Svg>

      <InnerLabelOuter
        scale={scale}
        {...dl}
        xAxis={isMobile ? mobileLabelAxis?.[0] : ""}
        yAxis={isMobile ? mobileLabelAxis?.[1] : ""}
      >
        <LabContainer
          {...dl}
          clr={clr} // ✅ preserved
          onClick={!isMobile ? () => click(labelsInfo) : null}
        >
          {/* ✅ ORIGINAL TEXT STRUCTURE KEPT */}
          <Lab clr={clr}>
            <Text1 className="h3" s={s} clr={clr}>
              {heading}
            </Text1>

            {/* ✅ ONLY EXTRA THING ADDED */}
            {isExpanded && getCommunityText(hoveredId) && (
              <Text3
                className="paragraph2-regular"
                clr={clr}
                style={{ marginTop: "8px" }}
              >
                {getCommunityText(hoveredId)}
              </Text3>
            )}
          </Lab>
        </LabContainer>
      </InnerLabelOuter>
    </Pos>
  );
};
